
app.pagesController = app.pagesController || {};
app.pagesController.defaultAction = {
   
    /**
     * Initialisation de la fonction
     * @returns {undefined}
     */
    singleActu : function () {
        if ($("#anoxaGallery").length > 0) {
            $("#anoxaGallery").unitegallery({
                tiles_type:"justified",
                tiles_justified_row_height: 100,
            });
        }

        if ($("#mnGallery").length > 0) {
            $("#mnGallery").unitegallery({
                tiles_type:"justified",
                tiles_justified_row_height: 100,
            });
        }

        if ($("#fvGallery").length > 0) {
            $("#fvGallery").unitegallery({
                tiles_type:"justified",
                tiles_justified_row_height: 100,
            });
        }

        if ($("#dtGallery").length > 0) {
            $("#dtGallery").unitegallery({
                tiles_type:"justified",
                tiles_justified_row_height: 100,
            });
        }
    },

    jobpage : function() {
        // Champs préremplis
        if ($('#jobTitle').length > 0) {
            $('#fld-poste').val($('#jobTitle').val());
        }

        if ($('#jobContract').length > 0) {
            $('#fld-contrat').val($('#jobContract').val());
        }

        $('.topBackToOffers, .bottomBackToOffers').on(app.clickEvent, function (e) {
            e.preventDefault();
            window.history.back();
        });
    },

    homepage : function() {
        $('.home .video-cards').slick(
            {
                dots: false,
                infinite: true,
                centerMode: true,
                variableWidth: true,
                autoplay: false,
                prevArrow: $('.block-slider-video .arrows .arrow-left'),
                nextArrow: $('.block-slider-video .arrows .arrow-right'),
                responsive: [],
            }
        );

    },
        
};

$(document).ready(function(){
    
    // Some page
    app.pagesController.defaultAction.singleActu();
    app.pagesController.defaultAction.jobpage();
    app.pagesController.defaultAction.homepage();
});
